export default {
  exclusiveOfferTitle: 'عرض حصري بانتظارك',
  exclusiveOfferDesc:
    'خصم خاص من تأميني على تأمين الأخطاء الطبية، مخصص لعملاء دكتور لاونج.',
  couponLabel: 'كوبون ضد الأخطاء الطبية',
  copyCoupon: 'نسخ الكوبون',
  buyNow: 'اشتر الآن',
  remindMeLater: 'ذكرني لاحقاً؟',
  backToCouponDetails: 'العودة إلى تفاصيل الكوبون',
  reminderFormTitle: 'يرجى ملء معلوماتك:',
  email: 'البريد الإلكتروني',
  emailPlaceholder: 'البريد الإلكتروني',
  emailExample: 'مثال: email@email.com',
  mobile: 'الجوال*',
  mobilePlaceholder: 'رقم الجوال',
  mobileExample: 'مثال: 05xxxxxxxx',
  reminderDatePlaceholder: 'التاريخ المناسب للشراء',
  captchaCode: 'رمز التحقق',
  captchaPlaceholder: 'رمز التحقق',
  reminderSavedToast: 'تم حفظ بياناتك بنجاح',
  // Validation messages
  validation: {
    emailRequired: 'البريد الإلكتروني مطلوب',
    emailInvalid:
      'البريد الإلكتروني المدخل غير صحيح، يرجى إدخال بريد إلكتروني صحيح',
    mobileRequired: 'رقم الجوال مطلوب',
    mobileInvalid: 'يرجى أدخال رقم جوال صحيح مكون من 10 أرقام',
    communicationDateRequired: 'التاريخ المناسب للشراء مطلوب',
    captchaRequired: 'رمز التحقق مطلوب',
  },
} as const
